export function createUrlParams(obj) {
  const searchParams = new URLSearchParams();

  Object.entries(obj).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      if (value.length > 0) {
        searchParams.set(key, value.join(','));
      }
    } else if (!!value) {
      searchParams.set(key, value.toString());
    }
  })
  
  return searchParams.toString();
}